const removeHTML = htmlText => {
  return htmlText.replace(/<\/?[^>]+(>|$)/g, '')
}

module.exports = removeHTML
